import React, { forwardRef, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly bundle: {
        readonly coverUrl?: string;
        readonly title?: string;
        readonly bundleId?: string;
    };
};

const BundleCover = forwardRef<HTMLImageElement, Props>(({ bundle }, ref) => {
    const { t } = useTranslation();
    const [isError, setIsError] = useState(false);
    const handleError = useCallback(() => setIsError(true), []);

    const title = t(`selectionList.groupedByItem.${bundle.bundleId}.title`, {
        defaultValue: bundle.title
    });

    if (!bundle.coverUrl || isError) {
        return (
            <div className="cover-alt" ref={ref}>
                <span>{title}</span>
            </div>
        );
    }

    return <img src={bundle.coverUrl} alt={bundle.title} title={title} onError={handleError} ref={ref} />;
});

export default BundleCover;
